import newClients from "../../assets/images/list-your-business/new-clients.svg";
import freeMarketing from "../../assets/images/list-your-business/free-marketing.svg";
import fillInYourEmptySpots from "../../assets/images/list-your-business/fill-your-empty-spots.svg";
import noUpfrontCost from "../../assets/images/list-your-business/no-upfront-cost.svg";
import signUp from "../../assets/images/list-your-business/sign-up.svg";
import list from "../../assets/images/list-your-business/list.svg";
import tap from "../../assets/images/list-your-business/tap.svg";
import generate from "../../assets/images/list-your-business/generate.svg";

export const listYourBusinessHeroItems = [
  {
    id: 1,
    title: "NewClients",
    text: "GetDiscoveredByThousandsOfNewClients",
    imagePath: newClients,
  },
  { id: 2, title: "FreeMarketing", text: "AccessTargetedPromotions", imagePath: freeMarketing },
  {
    id: 3,
    title: "FillInYourEmptySpots",
    text: "ListAvailableClassesAndFill",
    imagePath: fillInYourEmptySpots,
  },
  {
    id: 4,
    title: "NoUpfrontCost",
    text: "GetListed100freeNoSubscriptions",
    imagePath: noUpfrontCost,
  },
];

export const listYourBusinessHowItWorksItems = [
  { id: 1, title: "SignUp", text: "ToTheClubPlassPlatform", imagePath: signUp },
  { id: 2, title: "List", text: "YourOpenClassSpotsAppointments", imagePath: list },
  { id: 3, title: "Tap", text: "IntoOurBaseOfSubscribers", imagePath: tap },
  { id: 4, title: "Generate", text: "IncrementalRevenue", imagePath: generate },
];
